import * as React from "react";
import PropTypes from 'prop-types';

const SvgAccountWithDot = props => {
  if (props.id !== "_svgaccountwithdot") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 36c8.837 0 16-7.163 16-16S28.837 4 20 4 4 11.163 4 20s7.163 16 16 16zm7-9c1.035.48 2 1 2 2s-4 4-9 4-9-3-9-4c0-.988 1.005-1.497 1.966-1.983L13 27l3.232-1.745c.38-.192.601-.538.601-.898v-.339c-1.798-1.26-2.929-3.614-2.929-6.208 0-3.919 2.57-7.144 5.81-7.144 3.24 0 5.81 3.225 5.81 7.144 0 2.512-1.061 4.804-2.768 6.092v.491c0 .376.234.727.64.915L27 27z" fill="#202020" /><path d="M36.8 8a4.8 4.8 0 11-9.6 0 4.8 4.8 0 019.6 0z" fill="#E71324" /><path fillRule="evenodd" clipRule="evenodd" d="M40 8a8 8 0 11-16 0 8 8 0 0116 0zm-8 4.8a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6z" fill="#fff" /></svg>;
};

SvgAccountWithDot.displayName = "_svgaccountwithdot";
SvgAccountWithDot.propTypes = {
  id: PropTypes.string
};
SvgAccountWithDot.defaultProps = {
  id: ''
};
export default SvgAccountWithDot;